import { render } from "./FrenKampanasi.vue?vue&type=template&id=3783141e"
import script from "./FrenKampanasi.vue?vue&type=script&lang=js"
export * from "./FrenKampanasi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__